(function () {
    'use strict';

    angular.module('app')
        .constant('NG_TABLE_DEFAULT_PARAMS', {size: 20})
    ;
})();
